<template>
  <div class="">
    <div class="pt-3 m-auto text-left ">
      <div v-if="estudiante">
        <!--h2>Últimos Eventos</h2-->
          <b-button class="ml-2 mb-4" :class="{'active blue-dark':value.current}" size="md" v-for="(value, index) in filtros_estudiantes" :key="index"  variant="outline-primary" @click="cargar(value.nombre)" :title="value.nombre">{{value.nombre}}</b-button>
      </div>
      <div v-else>
        No hay información
      </div>
      
       <v-client-table 
       @row-click="rowClick" name="eventosEstudiantes" 
       :columns="columns" 
       :data="data" 
       :options="options" 
       :loading="loading">

        <div slot="created_at" slot-scope="item">{{ textoFecha(item.row.created_at) }}</div>
        <div slot="contenido" slot-scope="item">
            {{ getContenido(item.row) }}
        </div>
        <div slot="evento" slot-scope="item">
            {{ getEvento(item.row) }}
        </div>
        <div slot="comentarios" slot-scope="item">
            {{ getComentarios(item.row) }}
        </div>
        <div slot="loading" class="text-center my-4 text-primary">
          <!-- Spinner nativo de Bootstrap -->
          <div class="spinner-border" role="status">
            <span class="sr-only">Cargando...</span>
          </div>
          <p class="mt-2 font-weight-bold">Cargando registros...</p>
        </div>

        </v-client-table>
        
      <b-modal  v-model="showRow"  hide-footer title="Detalle del Evento">
          <div v-for="(value, key) in selectedRow">
            <div v-if="key !== 'contenido'">
              {{ key }}: {{ value }}
            </div>
            <div v-else>
              {{ key }}: <blockquote><span v-for="(v, k) in value" v-if="!['estudiante','tema', 'password', 'permisos'].includes(k)">{{ k }}: {{ v }}, </span></blockquote>
            </div>

          </div>
      </b-modal>

      <b-button v-if="hayMas" size="sm" variant="link" title="Ver más">Ver más</b-button>
      
      <b-button v-if="estudiante!=null" size="sm" variant="link" @click="reiniciar" title="Reiniciar">Reiniciar</b-button>
    </div>
    <b-alert show variant="info" v-if="info">{{ info }}</b-alert>
    <b-alert show variant="danger" v-if="error">{{ error }}</b-alert>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
  import Vue from 'vue'
  import axios from 'axios'
  import config from '@/config'

  export default {
    name: 'EstudianteEventos',
    components: {
    },
    props:{
      estudiante:Object
    },
    data () {
      return {
        loading:false,
        columns: ['created_at', 'usuario',  'evento', 'contenido', 'comentarios'],
        options: {
          filterable: false,
          filterByColumn: true,
          sortable:[],
          perPage: 10,
          perPageValues: [5, 10, 15, 20],
          headings: {
            created_at: 'Fecha',
            tipo: 'Tipo',
            usuario: 'Usuario',
            evento: 'Acción',
            contenido: 'Descripcion',
            comentarios: 'Comentarios',
          },
          texts: {
            // Texto plano que reemplaza al clásico "Loading..." por defecto
            loading: "Por favor espere, cargando datos...",
            noResults: "No se encontraron registros",
            noRequest:"Seleccione una opción para consultar",
          },
          sendInitialRequest: false,
        },
        filtros_estudiantes:[
          {nombre:'Activaciones',haymas: null, page:1, data:[], campo:'user_id', filtro:{evento:'usuario_cambiar_activo_ok', user_id:null}},
          {nombre:'Vigencias',haymas: null, page:1, data:[],campo:'estudiante_id', filtro:{evento:'estudiante_editar_vigencia_ok', estudiante_id:null}},
          {nombre:'Módulos',haymas: null, page:1, data:[],campo:'estudiante_id', filtro:{evento:'curso_activar_ok', estudiante_id:null}},
          {nombre:'Matriculas',haymas: null, page:1, data:[],campo:'estudiante_id', filtro:{evento:{$in:['estudiante_crear_ok','estudiante_activar_ok']}, estudiante_id:null}},
          {nombre:'Agendamientos',haymas: null, page:1, data:[],campo:'estudiante_id', filtro:{evento:'agendar_ok', estudiante_id:null}},
          
        ],
        showRow: false,
        selectedRow: null,
        error: null,
        info: null,
        data:[],
        diccionario:{
          'estudiante_editar_vigencia_ok':'Actualizar vigencia',
          'usuario_cambiar_activo_ok':'Actualizar activo', 
          'curso_activar_ok':'Activar módulo', 
          'estudiante_crear_ok':'Crear matrícula', 
          'estudiante_activar_ok':'Crear renovación', 
          'agendar_ok':'Agendar'
        },
        current:null

      }
    },    
    mounted () {
      
    },
    
    methods:{
      ...mapActions({
        
      }),
      ...mapMutations({
      }),
      reiniciar(){
        for(var i in this.filtros_estudiantes) {
          this.filtros_estudiantes[i].page = 1;
          this.filtros_estudiantes[i].haymas = null;
          this.filtros_estudiantes[i].data = [];
        }
        this.data = [];
      },
      cargar(tipo = null){
        let index = this.filtros_estudiantes.findIndex(x => x.nombre === tipo)
        this.current = index;
        if (index === -1) {
          this.setInfo("No ha seleccionado un tipo para filtrar")
          return;
        }
        this.filtros_estudiantes.forEach(x => x.current = false);
        this.filtros_estudiantes[index].current = true;
        let filters = this.filtros_estudiantes[index].filtro;
        filters[this.filtros_estudiantes[index].campo] = this.estudiante.id;
        if (config.EVENTS_API && config.BITACORA_TOKEN) {            
            let api = config.EVENTS_API+'event/search'
            let _BITACORA_TOKEN = config.BITACORA_TOKEN;
            axios.defaults.headers.common['Authorization'] = 'Bearer '+_BITACORA_TOKEN;
            this.loading=true;
            axios.post(api,{paginate:this.filtros_estudiantes[index].page,filters:filters}).then((response) => {
              this.filtros_estudiantes[index].data = response.data.datos.data
              this.data = response.data.datos.data;
              if(response.data.datos.lastPage>response.data.datos.page){
                  this.filtros_estudiantes[index].page = (response.data.datos.page*1)+1
                  this.filtros_estudiantes[index].haymas = true;
              }else{
                  this.filtros_estudiantes[index].haymas = false;
              }
              this.loading=false;
            })
        } else {
          this.setInfo("No esta configurado el servicio de consulta de eventos")
        }
      },
      getContenido(item) {
        if(item.evento === 'usuario_cambiar_activo_ok')
            if (item.contenido && item.contenido.estado) {
                return item.contenido.estado;
            } else {
                return item.contenido.activo ? item.contenido.activo : JSON.stringify(item.contenido)
            }
        else if(['estudiante_crear_ok','estudiante_activar_ok'].includes(item.evento))
            if (item.contenido && item.contenido.vigencia) {
                return "Vigencia: "+item.contenido.vigencia;
            } else {
                return JSON.stringify(item.contenido)
            }
        else if(item.evento === 'agendar_ok')
            if (item.fecha && item.hora) {
                return item.fecha+" "+item.hora;
            } else {
                return JSON.stringify(item.contenido)
            }
        else 
            return JSON.stringify(item.contenido);
      },
      getComentarios(item) {
        if(item.evento === 'usuario_cambiar_activo_ok')
            if (item.contenido && item.contenido.comentarios) {
                return item.contenido.comentarios;
            } else {
                return ''
            }
        else 
            return '';
      },
      getEvento(item) {
        return this.diccionario[item.evento] ? this.diccionario[item.evento] : item.evento;
      },
      rowClick(event){
        this.showRow = true
        this.selectedRow = event.row
      },
      textoFecha(value){
        return this.$moment(value).format('DD/MM/YYYY HH:mm:ss');
        // return utils.getTextoHora(value)
      },
      setError(text){
        this.error = text
        setTimeout(() => {
          this.error = null
        },3000)
      },
      setInfo(text){
        this.info = text
        setTimeout(() => {
          this.info = null
        },3000)
      }
      
    },
    computed:{
      ...mapState({
        
      }),
      ...mapGetters({
        
      }),
      dataCurrent() {
        let index = this.filtros_estudiantes.findIndex(x => x.current == true);
        if (index > -1) {
          return this.filtros_estudiantes[index].data
        }
        return [];
        
      },
      hayMas() {
        if (this.current && this.current > -1) {
          return this.filtros_estudiantes[this.current].haymas
        }
        return false;
      }
    }
    
  }
</script>

<style scope>
.btn-outline-primary:hover {
    background:linear-gradient(135deg, #0D4E8C 0%, #084079 50%, #052e5c 100%) !important;
}
.btn-outline-primary:not(:disabled):not(.disabled).active:focus {
    box-shadow: 0 0 0 0.2rem rgba(13 78 140, 0.5) !important;
}
  .blue-dark {
    background:linear-gradient(135deg, #0D4E8C 0%, #084079 50%, #052e5c 100%) !important;
  }
</style>